import React, { useEffect, useRef } from 'react';
import { SwitchGroup, SwitchGroupPanel } from '../components/SwitchGroup';
import Select, { StylesConfig } from 'react-select';
import { Segment, Tour } from 'src/types';
import { useGlobalProject } from 'src/utils/globals';
import RulesDescriptorComponent from './RulesDescriptorNew';
import { RulesDescriptor } from 'src/data/types/descriptor';
import { Checklist } from 'src/data/types/base';

export default function SegmentationSelector(props: {
    allSegments: Segment[],
    allTours: Tour[],
    allChecklists?: Checklist[],
    supportsEvents?: boolean,
    supportsChecklists?: boolean,
    supportsSurveys?: boolean,
    supportsAnnouncements?: boolean,
    selectedSegmentId?: number,
    onSegmentSelected: (id: number) => void,
    rules: RulesDescriptor,
    onRulesChanged: (descriptor: RulesDescriptor) => void,
    onAllUsersSelected: () => void,
    onTypeChanged?: (type: string | number) => void
}) {
    const optionizedSegments = props.allSegments.map(seg => ({ label: seg.name, value: seg.id }));
    const [selectedSegmentOption] = optionizedSegments.filter(i => i.value == props.selectedSegmentId);
    const project = useGlobalProject();

    const segmentsSelectStyles: StylesConfig<{ label: string, value: number }> = {
        control: (provided, state) => {
            return { ...provided, width: 'auto', maxWidth: '300px' };
        }
    }

    const getSelectedOption = () => {
        if (props.selectedSegmentId) return 'segment';
        if (props.rules && props.rules.rules && props.rules.rules.length > 0) return 'rules';
        return 'all';
    }

    const onItemChanged = (item: string | number) => {
        if (item == 'all') {
            props.onAllUsersSelected();
        }

        props.onTypeChanged && props.onTypeChanged(item);
    }

    return <SwitchGroup defaultItemId={getSelectedOption()} onSwitched={(i) => onItemChanged(i)} items={[
        {
            iconComponent: <i className="icon-all-users-32"></i>,
            id: 'all',
            text: 'All users'
        },
        {
            iconComponent: <i className="icon-segments-32"></i>,
            id: 'segment',
            text: 'Segment'
        },
        {
            iconComponent: <i className="icon-rules-32"></i>,
            id: 'rules',
            text: 'Custom rules'
        }
    ]}>
        <SwitchGroupPanel id='all'>
            <div></div>
        </SwitchGroupPanel>
        <SwitchGroupPanel id='segment'>
            <div className='d-flex align-items-center'>
                <Select
                    classNamePrefix='custom-select'
                    styles={segmentsSelectStyles}
                    placeholder='Select a segment...'
                    value={selectedSegmentOption}
                    options={props.allSegments.map(seg => ({ label: seg.name, value: seg.id }))}
                    //@ts-ignore
                    onChange={(item) => props.onSegmentSelected(item.value)} />

                <a href={`/${project.UniqueCode}/segments/manage`} className='ml-3 text-sm'>Manage segments...</a>
            </div>
        </SwitchGroupPanel>
        <SwitchGroupPanel id='rules'>
            <RulesDescriptorComponent
                allTours={props.allTours}
                allChecklists={props.allChecklists}
                rulesDescriptor={props.rules}
                supportsEvents={props.supportsEvents}
                supportsSurveys={props.supportsSurveys}
                supportsAnnouncements={props.supportsAnnouncements}
                supportsChecklistStates={props.supportsChecklists}
                onChanged={props.onRulesChanged} />
        </SwitchGroupPanel>
    </SwitchGroup>
}
